module.exports = __webpack_public_path__ + "img/481356.0f4aebd6.svg";